/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RoleSortCriteria {
    getFixupPrototypeFunction() { return RoleSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<RoleSortCriteria>): RoleSortCriteria {
        let obj = Object.assign(new RoleSortCriteria(), model);
        RoleSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RoleSortCriteria>): RoleSortCriteria {
        if (!model) return null;
        return RoleSortCriteria.newInstance(<RoleSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RoleSortCriteria) {
        if (!obj) return;

        models.RoleSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RoleSortCriteria): boolean {
        Object.setPrototypeOf(obj, RoleSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.RoleSortColumn;

    ascending: boolean;

}
